import type { FormattedCourse } from 'bundles/enroll-common/types/enrollSectionTypes';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

export const getFormattedCourseDataFromConsumerSpecializationPageFieldsFragment = (
  data: ConsumerSpecializationPageFieldsFragment
): FormattedCourse[] => {
  if (!data.courses || data.courses?.length < 1) {
    return [];
  }

  return data.courses.map((course) => ({
    id: course.id,
    slug: course.slug,
    name: course.name,
    link: `/learn/${course.slug}`,
    homeLink: `/learn/${course.slug}/home/welcome`,
  }));
};

export const getFormattedCourseDataFromConsumerCoursePageFieldsFragment = (
  data: ConsumerCoursePageFieldsFragment
): FormattedCourse => {
  const today = new Date();
  const isLaunched = !!data.launchedAt && new Date(data.launchedAt) < today;

  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    isAuditable: data.premiumExperienceVariant === 'PREMIUM_GRADING',
    isClosedCourse: data.premiumExperienceVariant === 'PREMIUM_COURSE',
    isLaunched,
    isPreEnroll: data.courseStatus === 'PRE_ENROLL',
    link: `/learn/${data.slug}`,
    homeLink: `/learn/${data.slug}/home/welcome`,
    partnerIds: data.partners?.map((partner) => partner.id),
    s12nIds: data.specializations?.map((specialization) => specialization.id),
  };
};
